// ActionsFloatButton.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useState } from 'react';
import { RocketOutlined } from '@ant-design/icons';
import { FloatButton, Tooltip } from 'antd';
import { createPortal } from 'react-dom';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const ActionsFloatButton = ({
  trigger = 'click',
  icon = <RocketOutlined />,
  counter = null,
  floatActions = [], // {icon, tooltipText, onClick}
  disabled = false,
}) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const [open, setOpen] = useState(false);

  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleActionClick = item => {
    setOpen(false);
    if (typeof item.onClick === 'function') {
      item.onClick();
    }
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return createPortal(
    <FloatButton.Group
      type="primary"
      shape="circle"
      style={{ right: 24, bottom: 24, zIndex: 9999 }}
      trigger={trigger}
      open={open}
      onOpenChange={setOpen}
      badge={!isNaN(counter) && { count: counter }}
      icon={icon}
      disabled={disabled}
      tooltip={{
        title: translateX('document_actions'),
        placement: 'left',
      }}
    >
      {floatActions.map(item =>
        item.disabled ? (
          <Tooltip key={item.key} title={translateX(item.tooltipText)} placement="left">
            <div style={{ display: 'inline-block' }}>
              <FloatButton
                type="default"
                icon={<span style={{ color: 'gainsboro' }}>{item.icon}</span>}
                style={{ pointerEvents: 'none', boxShadow: 'none' }}
              />
            </div>
          </Tooltip>
        ) : (
          <FloatButton
            key={item.key}
            type={item.type}
            icon={item.icon}
            tooltip={{
              title: translateX(item.tooltipText),
              placement: 'left',
            }}
            onClick={() => handleActionClick(item)}
          />
        )
      )}
    </FloatButton.Group>,
    document.body
  );
};

export default ActionsFloatButton;
